export default __webpack_public_path__ + "static/media/pokedex-mb-generation.5b94fba3.png";